module.exports = __webpack_public_path__ + "media/images/unsplash_img_03-8d7eb600d1f03a3eed93976644ffe29d.jpeg";